import { render, staticRenderFns } from "./modalFaltantes.vue?vue&type=template&id=793be016&scoped=true"
import script from "./modalFaltantes.vue?vue&type=script&lang=js"
export * from "./modalFaltantes.vue?vue&type=script&lang=js"
import style0 from "./modalFaltantes.vue?vue&type=style&index=0&id=793be016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793be016",
  null
  
)

export default component.exports